<template>
    <div class="campaign-card">
        <div class="campaign-card-img" @click="clickCampaign()">
            <img :src="campaign.fullImageUrl"/>
        </div>
        <div class="discount" v-if="campaign.discount > 0">
            <div class="discount-img">
                <img src="../../../../assets/new/bg/bg-discount.png"/>
                <div class="discount-text">
                    <div class="text">ลด</div>
                    <div class="text">{{ getDiscount() }}%</div>
                </div>
            </div>
        </div>
        <div class="campaign-card-info">
            <div class="campaing-name">{{campaign.name}}</div>
            <div class="price-card">
                <div class="price-info">
                    <div class="price-unit">{{getUnit()}}</div>
                    <div class="original-price" v-if="blobConfig.app_redeem_type != 'point'">{{getOriginalPrice()}}</div>
                </div>
                <div class="add-card">
                    <img src="../../../../assets/new/icon/ic-add-card-active.png"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Account from "@/helper/AccountHelper.js";
import Util from "@/helper/Utility.js";
export default {
    name: 'RelatedItem',
    props: {
        lbl: Object,
        campaign: Object,
    },
    data: function() {
        return {
        }
    },
    created: function () {
        this.blobConfig = Account.getCacheBlob()
    },
    methods: {
        clickCampaign: function () {
            this.$router.push('/campaign/' + this.campaign.id);
        },
        //utilities
        getUnit: function() {
            if (this.blobConfig.app_redeem_type == "point") {
                return Util.stringFormat(this.lbl.B2B.campaign.point,Util.formatNum(Number(this.campaign.pointPerUnit)));
            } else {
                return Util.stringFormat(this.lbl.B2B.campaign.price,Util.formatNum(Number(this.campaign.pricePerUnit)));
            }
        },
        getOriginalPrice: function () {
            return Util.stringFormat(this.lbl.B2B.campaign.price,Util.formatNum(Number(this.campaign.originalPrice)));
        },
        getDiscount: function() {
            return Util.formatNum(this.campaign.discount)
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "@/style/base/baseImage.scss";
    @import "@/style/base/baseText.scss";

    .campaign-card{
    background-color: #fff;
    border-radius: 8px;

    .campaign-card-img {
        @include baseRatioImg(100%);
        position: relative;
        img {
            border: 0px;
            border-radius: 8px 8px 0 0;
        }
    }

    .campaign-card-info {
        padding: 8px;

        .campaing-name {
            @extend %ellipsis-2;
            height: 50px;
        }
        .price-card{
            display: flex;
            justify-content: space-between;
            .price-info {
                padding-top: 4px;
                font-family: $ff-medium;
                .price-unit{
                    font-size: $px16;
                    color: $a-red-ff0000;
                }
                .original-price{
                    font-size: $px12;
                    color: $a-gray-999999;
                    text-decoration-line: line-through;
                }
            }
            .add-card {
                flex: none;
                width: 40px;
                margin: auto 0;
                img{
                    width: 100%;
                }
            }
        }
    }

    .discount {
            position: absolute;
            top: 0px;
            right: 0px;
            .discount-img{
                position: relative;
                img {
                    width: 100%;
                    max-width: 30px;
                    height: auto;
                }
            }
            .discount-text {
                position: absolute;
                top: 0px;
                left: 0px;
                width: 100%;
                display: grid;
                grid-column: 1;
                font-size: $px10;
                color: white;
                .text {
                    display: flex;
                    justify-content: center;
                }
            }
    }
}

</style>
